import { StaffPreparationTask } from './StaffPreparationTask'

export enum WorkType {
    inSection = 'inSection',
    holiday = 'holiday',
    training = 'training',
    notInSection = 'notInSection'
}

export interface Work {
    id: number
    daycareId: number
    date: string
    start: string
    end: string
    preparationTasksBefore: StaffPreparationTask[]
    preparationTasksAfter: StaffPreparationTask[]
    preparationTimeBefore: number
    preparationTimeAfter: number
    totalDuration: number
    staff: number
    staffName: string
    staffLevelId?: number
    type: WorkType
    sectionGroupId?: number
    sectionGroupName?: string
    internalNote?: string
    externalNote?: string
}
